module.exports = __webpack_public_path__ + "static/media/thumbnail.c9ca80e5.jpg";